import { useMemo, useEffect } from 'react';
import { useAppSelector } from '../../../redux/Store';
import {
  getScriptState,
  getAdditionalPhotoLabels,
} from '../../../redux/reducer/coreScriptReducer';
import { ImageMetadata } from '../../../types/ui';

const useMediaLabels = (
  tab: 'all' | 'fulfilled' | 'additional' | 'unfulfilled' = 'all'
) => {
  const scriptState = useAppSelector(getScriptState);
  const additional = useAppSelector(getAdditionalPhotoLabels);

  const count = useMemo(() => {
    const data = scriptState?.Media?.List
      ? Object.values(scriptState?.Media?.List)
      : [];

    const fulfilled = data.filter((item) => item.Complete).length;
    const unfulfilled = data.filter((item) => !item.Complete).length;
    const additionalCount = additional.filter(
      (item) => item.Images && item.Images.length > 0
    ).length;

    return {
      all: data.length,
      fulfilled,
      unfulfilled,
      additional: additionalCount,
    };
  }, [scriptState, additional]);

  const mediaLabels = useMemo(() => {
    const data = scriptState?.Media?.List
      ? Object.values(scriptState?.Media?.List)
      : [];

    if (tab === 'fulfilled' || tab === 'unfulfilled') {
      const filtered = data.filter((item) =>
        tab === 'fulfilled' ? item.Complete : !item.Complete
      );
      return filtered;
    }
    return data;
  }, [scriptState, tab]);

  const labels = useMemo(() => {
    const labelsData = mediaLabels.map((label) => label.Label);

    return labelsData;
  }, [mediaLabels]);

  const additionalPhotoLabels = useMemo(() => {
    return tab === 'additional' && additional ? additional : [];
  }, [additional, tab]);

  const getAdditionalImageGuidsByLabel = (label: string): ImageMetadata[] => {
    return additional.find((item) => item.Label === label)?.Images || [];
  };

  const getAllAdditionalImages = (): ImageMetadata[] => {
    return additional.flatMap((item) => item.Images || []);
  };
  const getAllAdditionalImagesForViewing = (): ImageMetadata[] => {
    return additional.flatMap((item) =>
      (item.Images || []).map((image) => ({
        ...image,
        label: item.Label,
      }))
    );
  };

  return {
    count,
    labels,
    mediaLabels,
    mediaList: scriptState?.Media?.List,
    additionalPhotoLabels,
    getAdditionalImageGuidsByLabel,
    getAllAdditionalImages,
    getAllAdditionalImagesForViewing,
  };
};

export default useMediaLabels;
